// 活动
const activityRouter = {
  path: '/activityIndex',
  name: 'ActivityIndex',
  component: () => import('@/views/activity/index')
}
export default activityRouter
